export const referralOptions = [
  {
    key: "google",
    label: "Google",
  },
  {
    key: "social_media",
    label: "Social Media (Facebook, Instagram, ...)",
  },
  {
    key: "project",
    label: "anderes Projekt",
  },
  {
    key: "tv",
    label: "Fernsehen",
  },
  {
    key: "radio",
    label: "Radio",
  },
  {
    key: "paper",
    label: "Zeitung",
  },
];

export const roleOptions = {
  sport: [
    "1. Vorstand",
    "Vorstandsmitglied",
    "Jugendleiter:in",
    "Trainer:in",
    "Spieler:in",
    "Elternteil",
  ],
  fire: [
    "1. Vorstand",
    "Vorstandsmitglied",
    "Stadt-/Gemeindebrandmeister:in",
    "Wehrleiter:in",
    "Mitglied",
    "Bürgermeister:in",
  ],
  carneval: ["1. Vorstand", "Vorstandsmitglied", "Elternteil", "Mitglied"],
  default: ["Vorstandsmitglied", "Mitglied"],
};

export const _roleOptions = [
  {
    key: "vorstand",
    label: "Vorstand / Leitung",
  },
  {
    key: "trainer",
    label: "Trainer",
  },
  {
    key: "spieler",
    label: "Spieler / Mitglied",
  },
  {
    key: "other",
    label: "Eltern / sonstige",
  },
];

export const communityRoleOptions = [
  {
    key: "orga",
    label: "Organisator",
  },
  {
    key: "guest",
    label: "Gast / Interessent",
  },
];

export const communityTypes = [
  {
    key: "sport",
    label: "Sport",
  },
  {
    key: "carneval",
    label: "Karneval",
  },
  {
    key: 'shooting-club',
    label: 'Schützenverein',
  },
  {
    key: "school",
    label: "Schule / Abschlussklasse",
  },
  {
    key: "other",
    label: "Sonstige",
  },
];

export const posBrands = [
  {
    key: "rewe",
    label: "REWE",
  },
  {
    key: "edeka",
    label: "EDEKA",
  },
  {
    key: "aldi",
    label: "Aldi",
  },
  {
    key: "real",
    label: "real",
  },
  {
    key: "globus",
    label: "Globus",
  },
  {
    key: "marktkauf",
    label: "Marktkauf",
  },
  {
    key: "famila",
    label: "famila",
  },
  {
    key: "kaufland",
    label: "Kaufland",
  },
  {
    key: "billa",
    label: "Billa",
  },
  {
    key: "Spar",
    label: "Spar",
  },
  {
    key: "other",
    label: "Sonstige",
  },
];

export const communitySizeOptions = [
  {
    key: "500",
    label: "über 400",
  },
  {
    key: "400",
    label: "300-400",
  },
  {
    key: "300",
    label: "200-300",
  },
  {
    key: "200",
    label: "100-200",
  },
  {
    key: "100",
    label: "50-100",
  },
  {
    key: "50",
    label: "bis zu 50",
  },
];

export const countryOptions = [
  { key: "Deutschland", label: "Deutschland" },
  { key: "Österreich", label: "Österreich" },
  { key: "Schweiz", label: "Schweiz" },
];

export const stateOptions = [
  { key: "Baden-Württemberg", label: "Baden-Württemberg" },
  { key: "Bayern", label: "Bayern" },
  { key: "Berlin", label: "Berlin" },
  { key: "Brandenburg", label: "Brandenburg" },
  { key: "Bremen", label: "Bremen" },
  { key: "Hamburg", label: "Hamburg" },
  { key: "Hessen", label: "Hessen" },
  { key: "Mecklenburg-Vorpommern", label: "Mecklenburg-Vorpommern" },
  { key: "Niedersachsen", label: "Niedersachsen" },
  { key: "Nordrhein-Westfalen", label: "Nordrhein-Westfalen" },
  { key: "Rheinland-Pfalz", label: "Rheinland-Pfalz" },
  { key: "Saarland", label: "Saarland" },
  { key: "Sachsen", label: "Sachsen" },
  { key: "Sachsen-Anhalt", label: "Sachsen-Anhalt" },
  { key: "Schleswig-Holstein", label: "Schleswig-Holstein" },
  { key: "Thüringen", label: "Thüringen" },
];

export const salesReps = {
  "Tobias Lietz": {
    schedulerLink:
      "https://stickerstars.pipedrive.com/scheduler/Aao63C2/infotelefonat-stickerstars",
    pipedriveUserId: 12644947,
  },
  "Tobias Voß": {
    schedulerLink:
      "https://stickerstars.pipedrive.com/scheduler/WJBobf2O/infotelefonat-stickerstars",
    pipedriveUserId: 15247492,
  },
  Mirko: {
    schedulerLink:
      "https://stickerstars.pipedrive.com/scheduler/M0D75fYj/infogesprach-stickerstars",
    pipedriveUserId: 17511226,
  },
};

export const salesAssignments = {
  Deutschland: {
    _default: "Tobias Lietz",
    "Baden-Württemberg": "Tobias Voß",
    Bayern: "Tobias Voß",
    Berlin: "Tobias Lietz",
    Brandenburg: "Tobias Lietz",
    Bremen: "Tobias Lietz",
    Hamburg: "Tobias Lietz",
    Hessen: "Tobias Voß",
    "Mecklenburg-Vorpommern": "Tobias Lietz",
    Niedersachsen: "Tobias Lietz",
    "Nordrhein-Westfalen": "Tobias Lietz",
    "Rheinland-Pfalz": "Tobias Voß",
    Saarland: "Tobias Voß",
    Sachsen: "Tobias Lietz",
    "Sachsen-Anhalt": "Tobias Lietz",
    "Schleswig-Holstein": "Tobias Lietz",
    Thüringen: "Tobias Voß",
  },
  Österreich: {
    _default: "Tobias Voß",
  },
  Schweiz: {
    _default: "Tobias Voß",
  },
};
